import { deleteCookie, getCookie, setCookie } from 'stash/utils/cookies';

const BANK_LINK_COOKIE_AGE = 1000 * 60 * 30; // 30 minutes

// store the returnPath so if the user is redirected back to the app from oauth
// we still have reference to the original returnPath set
const BANK_LINK_RETURN_PATH_NAME = 'stashBankLinkReturnPath';

export function getBankLinkReturnPathCookie() {
	return getCookie(BANK_LINK_RETURN_PATH_NAME);
}

export const deleteBankLinkReturnPath = () => {
	deleteCookie(BANK_LINK_RETURN_PATH_NAME);
};

export const storeBankLinkReturnPath = (returnPath) => {
	setCookie(BANK_LINK_RETURN_PATH_NAME, returnPath, {
		'max-age': BANK_LINK_COOKIE_AGE,
	});
};

// store the skipMicros so if the user is redirected back to the app from oauth
const SKIP_MICROS = 'skipMicros';

export function getSkipMicrosCookie() {
	return getCookie(SKIP_MICROS);
}

export const deleteSkipMicros = () => {
	deleteCookie(SKIP_MICROS);
};
export const storeSkipMicros = (skipMicros) => {
	setCookie(SKIP_MICROS, skipMicros, {
		'max-age': BANK_LINK_COOKIE_AGE,
	});
};

// for oauth, plaid needs to resume with the same plaidToken that
// initiated the link session
const BANK_LINK_PLAID_TOKEN_NAME = 'stashBankLinkPlaidToken';

export function getBankLinkPlaidTokenCookie() {
	return getCookie(BANK_LINK_PLAID_TOKEN_NAME);
}

export const storeBankLinkPlaidToken = (plaidToken) => {
	setCookie(BANK_LINK_PLAID_TOKEN_NAME, plaidToken, {
		'max-age': BANK_LINK_COOKIE_AGE,
	});
};

export const deleteBankLinkPlaidToken = () => {
	deleteCookie(BANK_LINK_PLAID_TOKEN_NAME);
};

// in order for smaug to direct to the correct app, we need to set a cookie
// currently it checks that the stashBankLinkOrigin is `signup` to go to web-reg
export const storeBankLinkOrigin = () => {
	setCookie('stashBankLinkOrigin', 'app');
};

/**
 * Display the cross sell modal if the origin path is one of the cross sell origin paths.
 * @param {*} originPath The path of origination before opening the bank link modal.
 * @returns true or false
 */
export const displayCrossSellModal = (originPath) => {
	const crossSellOriginPaths = [
		'/',
		'/manage-bank-account',
		'/plan-details',
		'/change-payment-method',
	];
	return crossSellOriginPaths.includes(originPath);
};

const BANK_LINK_CARD_DETAILS = 'stashBankLinkCardDetails';

export const storeBankLinkCardDetails = (cardsObj) => {
	if (cardsObj) {
		window.sessionStorage.setItem(BANK_LINK_CARD_DETAILS, JSON.stringify(cardsObj));
	}
};

export const getBankLinkCardDetails = () => {
	const cardDetailsString = window.sessionStorage.getItem(BANK_LINK_CARD_DETAILS);
	if (cardDetailsString) {
		return JSON.parse(cardDetailsString);
	} else {
		return;
	}
};

export const deleteBankLinkCardDetails = () => {
	window.sessionStorage.removeItem(BANK_LINK_CARD_DETAILS);
};
